import React from 'react';
import classNames from 'classnames';

interface Props {
  value: boolean;
  onChange: (value: boolean) => void;
  label: string;
  id: string;
  isSideBySide?: boolean;
}

export const YesNo = (props: Props) => {
  const {
    id,
    value,
    onChange,
    label,
    isSideBySide,
  } = props;

  const isYesActive = !!value;
  const isNoActive = !value;

  return (
    <div className={classNames('YesNo', { 'YesNo--sideBySide': isSideBySide })} id={`${id}-yes-no`}>
      <legend className="YesNo-label">
        {label}
      </legend>

      <div className="YesNo-container">
        <div className="YesNo-buttons">
          {/* Yes */}
          <label className={classNames('YesNo-left', { isActive: isYesActive })} htmlFor={`${id}-yes`}>
            <input
              className="YesNo-button"
              id={`${id}-yes`}
              value="yes"
              checked={isYesActive}
              type="radio"
              onChange={() => onChange(true)}
            />
            <span>Yes</span>
          </label>

          {/* No */}
          <label className={classNames('YesNo-right', { isActive: isNoActive })} htmlFor={`${id}-no`}>
            <input
              className="YesNo-button"
              id={`${id}-no`}
              value="no"
              checked={isNoActive}
              type="radio"
              onChange={() => onChange(false)}
            />
            <span>No</span>
          </label>
        </div>
      </div>
    </div>
  );
};
